<template>
  <v-container>
   
    <v-row>
      <v-col cols="6">
        <AccountView v-if="showComponent == 'account'" class="my-4" />
        <PasswordView v-if="showComponent == 'password'" class="my-4" />
      </v-col>
    </v-row>

 </v-container>
</template>

<script setup>
import { inject, onMounted, ref, watch } from 'vue'
import AccountView from '@/components/objects/user/AccountView.vue'
import PasswordView from '@/components/objects/user/PasswordView.vue'



const updateDocumentHead = inject('updateDocumentHead');
import { useRoute } from 'vue-router'
const route = useRoute();

const showComponent = ref('account');

watch(
  () => route.params.type,
  (newType) => {
    if (newType === 'password') {
      showComponent.value = 'password';
    } else {
      showComponent.value = 'account';
    }
  },
  { immediate: true }
);

onMounted(() => {
  updateDocumentHead(
    "TeamWaizmann  | Account",
    "Jetzt Ihre Daten ändern, Passwort ändern oder Ihre Account-Daten löschen"
  );
});


</script>
